import React from "react";
import { MapPin, Clock } from "lucide-react";
import "./DeliveryAddress.css";

const DeliveryAddress = ({ address, deliveryNote, estimatedTime }) => {
  return (
    <div className="delivery-address">
      <h3 className="delivery-address__title">Delivery Address</h3>

      <div className="delivery-address__content">
        <div className="delivery-address__pin-icon">
          <MapPin className="delivery-address__pin-svg" />
        </div>
        <div className="delivery-address__address-wrapper">
          <p className="delivery-address__address">{address}</p>
          {deliveryNote && (
            <p className="delivery-address__deliveryNote">
              Delivery Note: {deliveryNote}
            </p>
          )}
        </div>
      </div>

      <div className="delivery-address__footer">
        <Clock className="delivery-address__clock-icon" />
        <span className="delivery-address__time">
          Estimated delivery: {estimatedTime}
        </span>
      </div>
    </div>
  );
};

export default DeliveryAddress;
